// src/utils/locales.js
// Pendant frontend de backend/utils/locales.js — source unique de normalisation
// des codes langue côté front. Voir docs/PLAN_I18N_MULTILANGUE.md.

export const PLATFORM_LOCALES = ['fr', 'en', 'es', 'it']
export const DEFAULT_LOCALE = 'fr'

// Autonymes : le nom d'une langue dans cette langue. NE SE TRADUIT PAS — on
// n'écrit pas « Italien » dans une interface en français quand on demande à
// l'utilisateur de reconnaître sa propre langue. Ils ne passent donc jamais par
// i18next, et vivent ici plutôt que dans un composant : le sélecteur du header
// et le réglage de langue par défaut de l'admin lisent la même table.
export const LANGUAGE_AUTONYMS = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  it: 'Italiano',
}

// Drapeau associé à une langue — APPROXIMATION ASSUMÉE. Une langue n'est pas un
// pays : l'espagnol se parle bien au-delà de l'Espagne, le français bien au-delà
// de la France. C'est pourquoi le drapeau ne remplace JAMAIS l'autonyme, il
// l'accompagne : un hispanophone d'Argentine doit lire « Español », pas deviner
// sa langue depuis un drapeau qui n'est pas le sien.
//
// `en` → `gb` et non `us`, par cohérence avec une décision déjà prise côté
// backend : `INTL_LOCALES` (utils/eventDateTime.js) mappe 'en' sur 'en-GB' au
// motif que « nos utilisateurs anglophones sont majoritairement européens ».
// Deux tables qui divergeraient sur ce point donneraient un drapeau américain
// à côté de dates au format britannique.
export const LANGUAGE_FLAGS = { fr: 'fr', en: 'gb', es: 'es', it: 'it' }

// Classe CSS `flag-icons` (paquet déjà utilisé par la carte et TalentSearch).
// Chaîne vide si la langue est inconnue : l'appelant rend alors l'autonyme seul,
// plutôt qu'un carré vide qui ressemblerait à une image cassée.
export function localeFlagClass(lang) {
  const code = LANGUAGE_FLAGS[lang]
  return code ? `fi fi-${code}` : ''
}

// Repli explicite : un code inconnu s'affiche en majuscules plutôt que de
// rendre une cellule vide, ce qui rendrait le réglage illisible.
export function localeLabel(lang) {
  return LANGUAGE_AUTONYMS[lang] || String(lang || '').toUpperCase()
}

// 'en-US' → 'en', 'es_CO' → 'es', 'de'/''/null → 'fr'. Toujours une locale valide.
export function normalizeLocale(input) {
  const lang = String(input || '')
    .toLowerCase()
    .split(/[-_]/)[0]
    .trim()
  return PLATFORM_LOCALES.includes(lang) ? lang : DEFAULT_LOCALE
}

// Normalise une liste (tableau OU CSV) de langues supportées par le tenant,
// dédupliquée, en garantissant la présence du fallback 'fr'.
export function parseSupported(arrOrCsv) {
  const list = Array.isArray(arrOrCsv)
    ? arrOrCsv
    : String(arrOrCsv || DEFAULT_LOCALE).split(',')
  const norm = list.map(normalizeLocale)
  const unique = [...new Set(norm)]
  if (!unique.includes(DEFAULT_LOCALE)) unique.unshift(DEFAULT_LOCALE)
  return unique
}
